import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

export const InfoCenterDocumentCategoryListApi = (data) =>
    API.get(`${URL.GET_ALL_INFO_CENTER_DOCUMENT_CATEGORY_LIST}`, data.params)

//
export const InfoCenterDocumentSubCategoryListApi = (data) =>
    API.get(`${URL.GET_ALL_INFO_CENTER_DOCUMENT_SUB_CATEGORY_LIST}`, data.params)

///

export const DocumentListApi = (data) => API.get(`${URL.GET_ALL_INFO_CENTER_DOCUMENT_LIST}`, data.params)